export default "__VITE_ASSET__DOqkKKjO__"